import React, { useState, useEffect, Fragment, useRef } from 'react';
import './comentario.css';
import { useForm } from '../../../hooks/useForm';
import { useAxiosPost } from '../../../hooks/useAxiosPost';
import { IoClose } from "react-icons/io5";
import { useTranslation } from 'react-i18next';

const Comenta = ({ popup, setPopup }) => {

    const [count, setCount] = useState(0);
    const [t2] = useTranslation("detail_blog");
    const [isSent, setIsSent] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const dialogRef = useRef(null);

    const {
        onInputChange,
        nombre,
        apellido,
        correo,
        ciudad,
        body,
        onResetForm
    } = useForm({
        nombre: '',
        apellido: '',
        correo: '',
        ciudad: '',
        body: '',
    });

    const [t, i18n] = useTranslation("global");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const notAllowedChars = [
        '"',
        '`',
        '=',
        ';',
        '[',
        ']',
        '{',
        '}',
        '/',
        '\\',
        '&',
        '<',
        '>',
        ':',
        '\''
    ];

    const handleInputChangeValidated = (event) => {

        onInputChange(event);

        const value = event.target.value;

        const containsNotAllowedChars = notAllowedChars.some(char =>
            value.includes(char)
        );

        let cleanBody = '';

        if (containsNotAllowedChars) {

            event.target.classList.add("invalid");

            for (let character of value) {
                cleanBody += notAllowedChars.includes(character)
                    ? ''
                    : character;
            }

            onInputChange({
                target: {
                    name: 'body',
                    value: cleanBody
                }
            });

        } else {

            event.target.classList.remove("invalid");

        }

        setCount(value.length);
    };

    const handleClose = () => {

        setPopup(false);
        setIsSent(false);

        onResetForm();

        setCount(0);

        dialogRef.current?.close();
    };

    const fromName = `${nombre} ${apellido}`.trim();

    const { data, isLoading, error } = useAxiosPost(
        formSubmitted
            ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-comment'
            : null,
        {
            fromName: " ",
            from: ' ',
            to: ' ',
            subject: 'Contacto Ricardo Salinas',
            body:
                "Nuevo comentario al contacto del Home\n\n\n" +
                fromName +
                "\n" +
                correo +
                "\n" +
                ciudad +
                '\n\nComentario: \n' +
                body,
            isBodyHtml: false
        }
    );

    const onFormSubmit = (event) => {

        event.preventDefault();

        if (!nombre.trim()) {
            alert(t2('comments.v_nombre'));
            return;
        }

        if (!correo.trim()) {
            alert(t2('comments.v_email'));
            return;
        }

        if (!emailRegex.test(correo)) {
            alert(t2('comments.v_valido'));
            return;
        }

        if (!body.trim()) {
            alert(t2('comments.v_comentario'));
            return;
        }

        setFormSubmitted(true);
    };

    useEffect(() => {

        if (formSubmitted && !isLoading && !error) {

            setIsSent(true);
            setFormSubmitted(false);
            onResetForm();

        }

    }, [isLoading, error]);

    useEffect(() => {

        if (popup) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }

    }, [popup]);

    return (
        <dialog ref={dialogRef} className="write-me-modal">

            <section className="write-me-modal__panel">

                <button
                    type="button"
                    className="write-me-modal__close"
                    onClick={handleClose}
                >
                    ✕
                </button>

                <form
                    className="write-me-modal__form"
                    onSubmit={onFormSubmit}
                    autoComplete="off"
                >

                    <div className="write-me-modal__body">

                        {
                            !isSent ? (
                                <>

                                    <h2 className="write-me-modal__title">
                                        {t('forms.titulo1')}
                                    </h2>

                                    <p className="write-me-modal__subtitle">
                                        {t('forms.text1')}
                                    </p>

                                    <label className="write-me-modal__field">

                                        <span className="write-me-modal__field-label">
                                            {t('forms.name')}*
                                        </span>

                                        <input
                                            type="text"
                                            name="nombre"
                                            value={nombre}
                                            onChange={onInputChange}
                                            className="write-me-modal__field-control"
                                        />

                                    </label>

                                    <label className="write-me-modal__field">

                                        <span className="write-me-modal__field-label">
                                            {t('forms.last_name')}
                                        </span>

                                        <input
                                            type="text"
                                            name="apellido"
                                            value={apellido}
                                            onChange={onInputChange}
                                            className="write-me-modal__field-control"
                                        />

                                    </label>

                                    <label className="write-me-modal__field">

                                        <span className="write-me-modal__field-label">
                                            {t('forms.email')}*
                                        </span>

                                        <input
                                            type="email"
                                            name="correo"
                                            value={correo}
                                            onChange={onInputChange}
                                            className="write-me-modal__field-control"
                                        />

                                    </label>

                                    <label className="write-me-modal__field">

                                        <span className="write-me-modal__field-label">
                                            {t('forms.city')}
                                        </span>

                                        <input
                                            type="text"
                                            name="ciudad"
                                            value={ciudad}
                                            onChange={onInputChange}
                                            className="write-me-modal__field-control"
                                        />

                                    </label>

                                    <label className="write-me-modal__field write-me-modal__field--textarea">

                                        <span className="write-me-modal__field-label">
                                            {t('forms.comment')}* ({count}/560)
                                        </span>

                                        <textarea
                                            name="body"
                                            value={body}
                                            onChange={handleInputChangeValidated}
                                            maxLength={560}
                                            className="write-me-modal__field-control write-me-modal__field-control--textarea"
                                        />

                                    </label>

                                    <button
                                        type="submit"
                                        className="write-me-modal__submit"
                                    >
                                        {isLoading
                                            ? t('forms.sending')
                                            : t('forms.send')}
                                    </button>

                                    <p className="write-me-modal__legal">
                                        {t('forms.accept2')}
                                    </p>

                                </>
                            ) : (

                                <div className="write-me-modal__success">

                                    <img
                                        className='img-success-pal'
                                        src='/assets/img2026/palomita.svg'
                                        alt='success'
                                    />

                                    <h2 className="write-me-modal__title">

                                        {
                                            i18n.language === "en"
                                                ? "Thank you for contacting us."
                                                : "Gracias por contactarnos."
                                        }

                                    </h2>

                                    <button
                                        type="button"
                                        className="btnSuscri subscribe-modal__submit typo-book-title"
                                        onClick={handleClose}
                                    >
                                        {
                                            i18n.language === "en"
                                                ? "Close"
                                                : "Cerrar"
                                        }
                                    </button>

                                </div>

                            )
                        }

                    </div>

                </form>

            </section>

        </dialog>
    );
};

export default Comenta;